import Vue from 'vue'
import commonJs from "@/utils/common.js"

Vue.filter('phone_desensitize', function (value) {
  if (!value) return '';
  var str = String(value);
  // 对电话号码进行脱敏处理
  return str.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
});

Vue.filter('name_desensitize', function (value) {
  if (!value) return '';
  var str = String(value);
  // 对姓名进行脱敏处理
  return str.replace(/^(.{1}).+(.)/, "$1**$2");
});

Vue.filter('idcard_desensitize', function (value) {
  if (!value) return '';
  var str = String(value);
  // 对身份证进行脱敏处理
  return str.replace(/^(.{4})(?:\d+)(.{4})$/, "$1******$2");
});

Vue.filter('email_desensitize', function (value) {
  if (!value) return '';
  var str = String(value);
  // 对邮箱进行脱敏处理
  return str.replace(/(.{0,3}).*@(.*)/, "$1***@$2");
});

Vue.filter('address_desensitize', function (value) {
  if (!value) return '';
  var str = String(value);
  var start = str.length / 2;
  var first_str = "";
  for (let i = 0; i < start; i++) {
    first_str += "*"
  }
  var end_str = str.slice(start);
  return first_str + end_str;
});

Vue.filter('sort_date', function (value) {
  if (!value) return '';
  var str = String(value);
  return commonJs.toDateString(str);
});

Vue.filter('long_date', function (value) {
  if (!value) return '';
  var str = String(value);
  return commonJs.toDatetimeString(str);
});

Vue.filter('interval_days', function (value) {
  if (!value) return '';
  var str = String(value);
  return commonJs.getIntervalDays(str, new Date());
});
